export default "__VITE_ASSET__lEz__PcS__"